<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "NOV City Completeness",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "NOV City Completeness",
      items: [
        {
          text: "Home",
        },
         {
          text: "Reports",
        },
        {
          text: "NOV City Completeness",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>